import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class SystemStatusRoutingService {
    private openSelectedFcuSrc$ = new Subject<string>();
    private openSelectedFuIndex$ = new Subject<{ fcuSrc: string; fuIndex: number }>();
    private openSelectedCommIFIndex$ = new Subject<number>();
    private openFcuListPage$ = new Subject<void>();

    openSelectedFcu(selectedFcuSrc) {
        this.openSelectedFcuSrc$.next(selectedFcuSrc);
    }

    openSelectedFu(selectedFuIndex) {
        this.openSelectedFuIndex$.next(selectedFuIndex);
    }

    openSelectedCommIF(selectedCommIFIndex) {
        this.openSelectedCommIFIndex$.next(selectedCommIFIndex);
    }

    openFcuListPage() {
        this.openFcuListPage$.next();
    }

    selectedFcuIndexSubject(): Subject<string> {
        return this.openSelectedFcuSrc$;
    }

    selectedFuIndexSubject(): Subject<{ fcuSrc: string; fuIndex: number }> {
        return this.openSelectedFuIndex$;
    }

    selectedCommIFIndexSubject(): Subject<number> {
        return this.openSelectedCommIFIndex$;
    }

    openFcuListPageSubject(): Subject<void> {
        return this.openFcuListPage$;
    }
}
